import { render, staticRenderFns } from "./EditPriceList.vue?vue&type=template&id=4137572b&scoped=true&"
import script from "./EditPriceList.vue?vue&type=script&lang=js&"
export * from "./EditPriceList.vue?vue&type=script&lang=js&"
import style0 from "./EditPriceList.vue?vue&type=style&index=0&id=4137572b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4137572b",
  null
  
)

export default component.exports